module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cec7826ea298dd0aed3a4c9cedaa3c71.png";